import {
  closestCorners,
  DndContext,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import ActionButton from "components/common/ActionButton";

import { Button, Form, Row, Spinner, Table } from "react-bootstrap";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { useFetchSocialPlatforms } from "../../../../hooks/useFetchSocialPlatforms";
import { useMemo } from "react";
import DocumentDropzone from "./DocumentDropzone";

const SortableItem = ({ id, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <tr ref={setNodeRef} style={style}>
      <td
        {...listeners}
        {...attributes}
        style={{
          cursor: "grab",
          textAlign: "center",
          width: "10px",
          // paddingTop: "15px",
        }}
      >
        ☰
      </td>
      {children}
    </tr>
  );
};

const StoreDocuments = () => {
  const {
    register,
    getValues,
    watch,
    control,
    setValue,
    formState: { errors },
  } = useFormContext();
  const { state } = useLocation();
  const navigate = useNavigate();

  const {
    fields: storeDocuments,
    append: appendStoreDocuments,
    remove: removeStoreDocuments,
    move,
  } = useFieldArray({
    control,
    name: "storeDocuments",
  });

  const sensors = useSensors(
    useSensor(MouseSensor),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 250,
        tolerance: 5,
      },
    }),
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = storeDocuments.findIndex(
        (item) => item.id === active.id,
      );
      const newIndex = storeDocuments.findIndex((item) => item.id === over.id);
      move(oldIndex, newIndex);
    }
  };

  const { data, isLoading } = useFetchSocialPlatforms();
  const storeDocumentsValues = watch("storeDocuments") || [];

  const platforms = data?.data?.data || [];

  const platformById = useMemo(() => {
    return platforms.reduce((acc, p) => {
      acc[p.id] = p;
      return acc;
    }, {});
  }, [platforms]);

  const documentType = ["Cheque Copy", "Legal Document"];

  if (isLoading) {
    return <Spinner variant="primary" animation="border" />;
  }

  return (
    <>
      {/* <Card.Header as="h6" className="bg-body-tertiary mb-2">
        Shipping And Warranty
      </Card.Header> */}

      {isLoading ? (
        <div className="d-flex py-3 justify-content-center align-items-center">
          <Button variant="falcon-default" size="sm" className="fs-10">
            Loading...
          </Button>
        </div>
      ) : (
        <Row className="gx-2 ">
          <DndContext
            sensors={sensors}
            collisionDetection={closestCorners}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={storeDocuments.map((item) => item.id)}
              strategy={verticalListSortingStrategy}
            >
              <Table responsive>
                <thead className="bg-200">
                  <tr>
                    <th
                      scope="col"
                      className="w-0 fs-10 text-center"
                      style={{ width: "10px" }}
                    >
                      Order
                    </th>

                    <th
                      scope="col"
                      className="fs-10"
                      style={{ width: "300px" }}
                    >
                      Type
                    </th>
                    <th scope="col" className="fs-10">
                      Document
                    </th>

                    <th
                      scope="col"
                      style={{ padding: "9px", width: "10px" }}
                      className=" text-end"
                    >
                      <ActionButton
                        icon="plus"
                        variant="success"
                        title="Add"
                        className="px-1 py-0"
                        onClick={() => appendStoreDocuments({})}
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {storeDocuments.map((item, index) => (
                    <SortableItem key={item.id} id={item.id}>
                      <td style={{ padding: "5px" }}>
                        <Form.Group controlId="formGroupName">
                          <Form.Select
                            aria-label="documentType"
                            isInvalid={
                              !!errors.storeDocuments?.[index]?.documentType
                            }
                            {...register(
                              `storeDocuments[${index}].documentType`,
                            )}
                          >
                            <option value="">Select</option>
                            {documentType?.map((d) => (
                              <option value={d}>{d}</option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.storeDocuments?.[index]?.documentType
                                ?.message
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </td>

                      <td style={{ padding: "5px" }}>
                        <DocumentDropzone index={index} />
                      </td>

                      <td
                        style={{ padding: "5px", maxWidth: "10px" }}
                        className="text-center"
                      >
                        <ActionButton
                          icon="trash-alt"
                          title="Delete"
                          variant="danger"
                          className="px-1 py-0"
                          onClick={() => removeStoreDocuments(index)}
                        />
                      </td>
                    </SortableItem>
                  ))}
                </tbody>
              </Table>
            </SortableContext>
          </DndContext>
        </Row>
      )}
    </>
  );
};

export default StoreDocuments;
